import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import { hydrate } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ensureReady } from "@jaredpalmer/after";
import ThemeProvider from "@/styles/ThemeProvider";
import ComposedProvider from "@/pages/ComposedProvider";
import { ErrorBoundary } from "../bootstrap";
import routes from "../routes";
import Root from "./Root";
import { loadableReady } from "@loadable/component";
import FoucFix from "./FoucFix";

import { FIREBASE_CONFIG } from "@/env";
// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
// Add the Performance Monitoring library
import "firebase/performance";
// Initialize Firebase
firebase.initializeApp(FIREBASE_CONFIG);
// Initialize Performance Monitoring and get a reference to the service
firebase.performance();


loadableReady(async () => {
  const data = await ensureReady(routes);
  hydrate(
    <ErrorBoundary>
      <ThemeProvider>
        <BrowserRouter>
          <ComposedProvider>
            <FoucFix />
            <Root data={data} routes={routes} />
          </ComposedProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>,
    document.getElementById("root")
  );
});

if ((module as any).hot) {
  (module as any).hot.accept();
}
